import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    // start with one ancestor row by default
    this.addRow()
  }

  addRow() {
    const fragment = this.templateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(fragment)
  }

  removeRow(event) {
    const card = event.target.closest(".card")
    if (card) card.remove()
  }
}
